import { BenefitDocumentDto } from '@zorro/clients';
import { VALIDATION_MESSAGES } from '@zorro/common-utils';
import { getTodayISO, parseDateISO } from '@zorro/shared/formatters';
import * as yup from 'yup';

import { planMarketEnrollmentValues } from '../EmployeeActions/EnrollmentActions/confirmEnrollmentForm.utils';

export const isCoverageStartingTodayOrLater = (effectiveFrom: string) =>
  parseDateISO(effectiveFrom).isSameOrAfter(getTodayISO());

export const enrollmentConfirmationSchema = yup.object({
  planMarket: yup
    .string()
    .required(VALIDATION_MESSAGES.planMarketRequired)
    .oneOf(planMarketEnrollmentValues, VALIDATION_MESSAGES.planMarketRequired),
  memberId: yup.string().when('noMemberAvailable', {
    is: true,
    then: (schema) => schema.notRequired().nullable(),
    otherwise: (schema) =>
      schema
        .required(VALIDATION_MESSAGES.memberIdRequired)
        .min(1, VALIDATION_MESSAGES.memberIdRequired),
  }),
  noMemberAvailable: yup.boolean(),
  confirmationEvidence: yup
    .mixed<(File | BenefitDocumentDto)[]>()
    .when('noEvidenceAvailable', {
      is: true,
      then: (schema) => schema.notRequired().nullable(),
      otherwise: (schema) =>
        schema
          .required(VALIDATION_MESSAGES.documentRequired)
          .test(
            'is-not-empty',
            VALIDATION_MESSAGES.documentRequired,
            (value) => Array.isArray(value) && value.length > 0
          ),
    }),
  noEvidenceAvailable: yup.boolean(),
  shouldSendEnrollmentConfirmationEmail: yup
    .boolean()
    .required(VALIDATION_MESSAGES.shouldSendEnrollmentConfirmationEmailRequired)
    .typeError(VALIDATION_MESSAGES.shouldSendEnrollmentConfirmationEmailValid),
  employeeMonthlyContribution: yup
    .number()
    .min(0, VALIDATION_MESSAGES.employeeMonthlyContributionNotNegative)
    .typeError(VALIDATION_MESSAGES.employeeMonthlyContributionNotNegative)
    .required(VALIDATION_MESSAGES.employeeMonthlyContributionRequired),
  premium: yup
    .number()
    .min(0, VALIDATION_MESSAGES.premiumPositive)
    .typeError(VALIDATION_MESSAGES.premiumRequired)
    .required(VALIDATION_MESSAGES.premiumRequired),
});

export type EnrollmentConfirmationFormFields = yup.InferType<
  typeof enrollmentConfirmationSchema
>;
